import React from 'react';
import PropTypes from 'prop-types';
import { useLocalizedPriceFormatter } from 'tradera-localization/use-localized-price-formatter';

const PriceLabel = ({
    tagName: TagName,
    className,
    price,
    hasDiscount,
    renderZero
}) => {
    const localizedPriceFormatter = useLocalizedPriceFormatter();

    if (!price && !(renderZero && price === 0)) {
        return null;
    }

    const formattedPrice = localizedPriceFormatter(price);

    return formattedPrice ? (
        <TagName className={`${hasDiscount ? 'text-danger' : ''} ${className}`}>
            {formattedPrice}
        </TagName>
    ) : null;
};
PriceLabel.propTypes = {
    tagName: PropTypes.string,
    className: PropTypes.string,
    price: PropTypes.number,
    hasDiscount: PropTypes.bool
};
PriceLabel.defaultProps = {
    tagName: 'span',
    className: ''
};

export default PriceLabel;
